import {BaseService} from "./base";
import {userInfoCache} from "../cache/userInfoCache";

class SystemService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 系统参数
   * @param key
   * @param defaultString
   * @returns {Promise<{}>}
   */
  async key(key, defaultString) {
    const {doc = {}} = userInfoCache.get() || {};
    const {code, obj} = await this.$http('smarthos.system.param.string', {
      // key, defaultString, hosId: doc.hosId
      key, defaultString, hosId: '1100000001'
    });
    if (code === '0') return obj;
  }

  /**
   * 发送验证码通用接口
   * @param mobile
   * @returns {Promise<void>}
   */
  async captcha(mobile) {
    const {code, obj = {}} = await this.$http('smarthos.captcha.common.get', {mobile});
    return code === '0' ? obj : {}
  }
}

export const systemService = new SystemService();
